module.exports = __webpack_public_path__ + "static/media/contact_head.6a90e724.jpeg";